export const Customer_API = `${process.env.REACT_APP_ZULAL_API_URL}/`;

export const Sonic_GetCountries_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v1/getCountries`;

export const Sonic_GetStates_URL = "/api/v2/sonic/geo/getStates";
export const Sonic_GetCities_URL = "/api/v2/sonic/geo/getCities?StateId=";
export const Sonic_GetAreas_URL = "/api/v2/sonic/geo/getAreas?CityId=";

export const Products_API_URL = "/api/v1/products/getProducts";

export const ZulalWalletTopUp_V2_API_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v2/customer/orders/topupconfirmation?ref=`;

export const OrderTrackingInfo_API_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v1/orders/getOrderTracking`;

export const GetSiteUpdatedProducts_API_URL =
  "/api/v2/customer/products/getpromolist";

export const GetProductsByPriceListCode_API_URL = "/api/v2/mosque/pricelist";

// V2 Multi Delivery Locations

export const SaveDeliveryLocation_API_V2_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v2/customer/saveDeliveryLocation`;

export const UpdateDeliveryLocation_API_V2_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v2/customer/updateDeliveryLocation`;

export const DeleteDeliveryLocation_API_V2_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v2/customer/deleteDeliveryLocation`;

// Locations updated API endpoints

export const GetDeliveryLocation_API_URL_V2 = `${process.env.REACT_APP_ZULAL_API_URL}/api/v2/customer/getDeliveryLocations`;

export const GetAnnouncement_API_URL = `${process.env.REACT_APP_ZULAL_API_URL}/api/v1/announcement`;

// Zulal V2 Web API endpoints

export const Auth_CurrentUser_URL = "/api/v2/customer/auth";
export const RequestOTP_URL = "/api/v2/otp/requestotp";
export const VerifyOTP_URL = "/api/v2/otp/verifyotp";
export const CustomerProfile_URL = "/api/v2/protected/profile";
export const UpdateCustomerProfile_URL = "/api/v2/customer/updateprofile";
export const MosqueOrders_API_URL = "/api/v2/customer/mosqueorders";
export const CheckPhone_URL = "/api/v2/customer/newphone/checknewphone";
export const createComplaint_API_URL_V2 = "/api/v2/customer/createcomplaint";
